import React, { FormEvent, useState } from "react";
import { toast } from "react-toastify";

import { IgButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import {
  FormControl,
  Grid,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "@src/store";

import { useShopifyLogin } from "../../api/shopify-callbacks/shopify-login";
import {
  selectedIsShopLogin,
  setEmailLogin,
  setShopLogin,
} from "../../store/slices/appSettings";
import { LoggedOrg } from "../../store/types/appSettings";

const PREFIX = "ShopLogin";

const classes = {
  paper: `${PREFIX}-paper`,
  paperHover: `${PREFIX}-paperHover`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.paper}`]: {
    minHeight: "100px",
    padding: "0px 10px 10px 10px",
  },

  [`& .${classes.paperHover}`]: {
    padding: "10px",
  },
}));

export const ShopLogin = () => {
  const isShopLogin = useSelector(selectedIsShopLogin);
  const loggedOrgs = useSelector((state) => state.appSettings.loggedOrgs);
  const dispatch = useDispatch();

  const shopifyLogin = useShopifyLogin();

  const [shopIdInput, setShopIdInput] = useState<string>("");

  const handleSubmit = (shopId: string, event?: FormEvent<HTMLFormElement>) => {
    if (event) event.preventDefault();

    if (shopId.length === 0) {
      toast.warning("Invalid Shopify Store Name");
      return;
    }
    shopifyLogin.mutate(shopId);
  };

  return (
    <StyledGrid container direction={"column"} rowSpacing={2} mt={1}>
      <Grid
        item
        container
        direction={"column"}
        rowSpacing={2}
        wrap={"nowrap"}
        sx={{ maxHeight: "300px", overflowY: "scroll" }}
      >
        {loggedOrgs.map((o: LoggedOrg) => {
          return (
            <Grid item xs key={o.shopId}>
              <IgPaper
                isClickable={true}
                className={classes.paperHover}
                variant={"outlined"}
                onClick={() => handleSubmit(o.shopId)}
              >
                <IgTypography variant="body1">{o.name}</IgTypography>
              </IgPaper>
            </Grid>
          );
        })}
      </Grid>
      <Grid item xs mt={2}>
        {
          <IgPaper className={classes.paper}>
            <form onSubmit={(event) => handleSubmit(shopIdInput, event)}>
              <Grid
                container
                direction={"column"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                spacing={2}
              >
                <Grid item xs mt={2}>
                  <IgTypography variant={"body1"}>
                    {`Don't see your store? Sign in below:`}
                  </IgTypography>
                </Grid>
                <Grid item xs style={{ width: "100%" }}>
                  <FormControl style={{ width: "100%" }}>
                    <OutlinedInput
                      id="manual-shop-id-input"
                      placeholder="my-awesome-shop"
                      value={shopIdInput}
                      onChange={(e) => setShopIdInput(e.target.value)}
                      startAdornment={
                        <InputAdornment position="end">https://</InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          .myshopify.com
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs style={{ width: "100%" }}>
                  <IgButton
                    loading={shopifyLogin.isPending}
                    variant="contained"
                    fullWidth
                    type="submit"
                    size="medium"
                  >
                    Sign In
                  </IgButton>
                </Grid>
              </Grid>
            </form>
          </IgPaper>
        }
        <Grid item xs mt={2} style={{ width: "100%" }}>
          <IgButton
            fullWidth
            size={"small"}
            variant={"text"}
            onClick={() =>
              dispatch(isShopLogin ? setEmailLogin() : setShopLogin())
            }
          >
            Log in with Username / Password
          </IgButton>
        </Grid>
      </Grid>
    </StyledGrid>
  );
};
